import { ref } from 'vue'
import  jwtDecode   from 'jwt-decode'
import axios from 'axios'
import { useRouter } from 'vue-router' 
import Swal from 'sweetalert2'

export function useAuth() {
  
  const errors = ref({})
  const router = useRouter()

  const getUser = () => {
    const token = localStorage.getItem('token');
    try {
      const decoded = jwtDecode(token)
      return {
        name: decoded.Name, 
        role: decoded.Role, 
        email: decoded.Email,
        ajustadorId: decoded.AjustadorId,
        hasSignature: localStorage.getItem('user_signature') || null,
      };
    } catch (error) {
      //console.error("Error decoding JWT token:", error)
      return false
    }
  }

  const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return token ? true : false;
  }

  const hasAuthorization = (roles) => {
    const token = localStorage.getItem('token');
    try {
      const decoded = jwtDecode(token)
      
      return roles.includes(decoded.Role);
    } catch (error) {
      console.error("Error decoding JWT token:", error)
      return false
    }
  }

  const login = async (username, password) => {
    errors.value = {}
    let message = ''
    try {

      Swal.fire({
          title: '...',
          text: 'Procesando petición, espere por favor',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          customClass: {
            popup: 'text-sm',   
            confirmButton: 'text-sm',
            cancelButton: 'text-sm'
          },
          didOpen: () => {
            Swal.showLoading()
          }
      })
      
      const response = await axios.post('usuarios/login', {
        username: username,
        password: password
      })

      const token = response.data.token
      localStorage.setItem('token', token)

      applySettings(token)
      verifySignature(token)

      const user = getUser();

      if(user.role === 'Agente Venta') {
        router.push('/aseguradoras')
      } else {
        router.push('/siniestros')
      }
      
      return true
    } catch (error) {
      if (error.response) {
        
        const status = error.response.status
        const data = error.response.data

        if ((status === 422 || status === 400) && data.errors) {
          errors.value = data.errors
        } else if (data.message) {
          message = data.message;
        } else {
          message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
          console.error('Error en la petición:', error.response)
        }
      } else {
        message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
        console.error('Error sin respuesta:', error)
      }

      if(message) {
        await Swal.fire({
            title: 'Lo sentimos!',
            text: message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#fd7527',
            customClass: {
              popup: 'text-sm',
              confirmButton: 'text-sm',
            }
        })
      }

      return false
    } finally {
        Swal.close()
    }
  }
  
  const forgotPassword = async (email) => {
      errors.value = {}
      let message = ''
      try {

        Swal.fire({
            title: '...',
            text: 'Procesando petición, espere por favor',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            customClass: {
              popup: 'text-sm',   
              confirmButton: 'text-sm',
              cancelButton: 'text-sm'
            },
            didOpen: () => {
              Swal.showLoading()
            }
        })
        
        const response = await axios.post('usuarios/forgot-password', {
          correo: email
        })

        await Swal.fire({
            title: 'Excelente!',
            text: response.data.message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#fd7527',
            customClass: {
              popup: 'text-sm',
              confirmButton: 'text-sm',
            }
        })
       
        return true
      } catch (error) {
        if (error.response) {
          
          const status = error.response.status
          const data = error.response.data

          if ((status === 422 || status === 400) && data.errors) {
            errors.value = data.errors
          } else if (data.message) {
            message = data.message;
          } else {
            message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
            console.error('Error en la petición:', error.response)
          }
        } else {
          message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
          console.error('Error sin respuesta:', error)
        }

        if(message) {
          await Swal.fire({
              title: 'Lo sentimos!',
              text: message,
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#fd7527',
              customClass: {
                popup: 'text-sm',
                confirmButton: 'text-sm',
              }
          })
        }

        return false
      } finally {
          Swal.close()
      }
  }

  const resetPassword = async (email, token, password) => {
      errors.value = {}
      let message = ''
      try {

        Swal.fire({
            title: '...',
            text: 'Procesando petición, espere por favor',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            customClass: {
              popup: 'text-sm',   
              confirmButton: 'text-sm',
              cancelButton: 'text-sm'
            },
            didOpen: () => {
              Swal.showLoading()
            }
        })
        
        const response = await axios.post('usuarios/reset-password', {
          correo: email,
          token: token,
          passwordNuevo: password
        })

        await Swal.fire({
            title: 'Excelente!',
            text: response.data.message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#fd7527',
            customClass: {
              popup: 'text-sm',
              confirmButton: 'text-sm',
            }
        })
       
        return true
      } catch (error) {
        if (error.response) {
          
          const status = error.response.status
          const data = error.response.data

          if ((status === 422 || status === 400) && data.errors) {
            errors.value = data.errors
          } else if (data.message) {
            message = data.message;
          } else {
            message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
            console.error('Error en la petición:', error.response)
          }
        } else {
          message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
          console.error('Error sin respuesta:', error)
        }

        if(message) {
          await Swal.fire({
              title: 'Lo sentimos!',
              text: message,
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#fd7527',
              customClass: {
                popup: 'text-sm',
                confirmButton: 'text-sm',
              }
          })
        }

        return false
      } finally {
          Swal.close()
      }
  }

  const changePassword = async (oldpassword, password) => {
      errors.value = {}
      let message = ''
      try {

        Swal.fire({
            title: '...',
            text: 'Procesando petición, espere por favor',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            customClass: {
              popup: 'text-sm',   
              confirmButton: 'text-sm',
              cancelButton: 'text-sm'
            },
            didOpen: () => {
              Swal.showLoading()
            }
        })

        const user = getUser();
        
        const response = await axios.post('usuarios/change-password', {
          correo: user.email,
          passwordActual: oldpassword,
          passwordNuevo: password
        })

        await Swal.fire({
            title: 'Excelente!',
            text: response.data.message,
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#fd7527',
            customClass: {
              popup: 'text-sm',
              confirmButton: 'text-sm',
            }
        })
       
        return true
      } catch (error) {
        if (error.response) {
          
          const status = error.response.status
          const data = error.response.data

          if ((status === 422 || status === 400) && data.errors) {
            errors.value = data.errors
          } else if (data.message) {
            message = data.message;
          } else {
            message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
            console.error('Error en la petición:', error.response)
          }
        } else {
          message = 'Ha ocurrido un error inesperado, intente de nuevo mas tarde'
          console.error('Error sin respuesta:', error)
        }

        if(message) {
          await Swal.fire({
              title: 'Lo sentimos!',
              text: message,
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#fd7527',
              customClass: {
                popup: 'text-sm',
                confirmButton: 'text-sm',
              }
          })
        }

        return false
      } finally {
          Swal.close()
      }
  }

  const logout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('color_base')
    localStorage.removeItem('user_signature')
    // Actualizar variable CSS global
    document.documentElement.style.setProperty('--primary-color', "#fd7527")
    router.push('/login')
  }

  const applySettings = (token) => {
    try {
      const decoded = jwtDecode(token)
      // Guardar color_base en localStorage
      localStorage.setItem('color_base', decoded.AseguradoraColorBase)
      localStorage.setItem('ruta_logo', decoded.AseguradoraRutaLogo)
      // Actualizar variable CSS global
      document.documentElement.style.setProperty('--primary-color', decoded.AseguradoraColorBase)
    } catch (error) {
      console.error("Error decoding JWT token:", error)
    }
  }

  const verifySignature = (token) => {
    try {
      const decoded = jwtDecode(token)
      if(decoded.HasSignature)
        localStorage.setItem('user_signature', decoded.HasSignature)
    } catch (error) {
      console.error("Error decoding JWT token:", error)
    }
  }

  return {
    errors, 
    isAuthenticated,
    hasAuthorization,
    login,
    logout,
    forgotPassword,
    resetPassword,
    changePassword,
    getUser
  }
}